exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tag-editable-field{font-size:12px;margin:-12px 16px 10px -30px\n}\n.tag-editable-field input{padding:0\n}\n.tag-editable-field .v-icon{color:transparent;font-size:20px;margin-right:-15px\n}\n.tag-editable-field .v-icon:hover{color:rgba(0,0,0,.54)\n}\n.tag-editable-field .v-input__icon--prepend .v-icon{margin-top:8px\n}\n.tag-editable-field .v-chip__content{height:26px;padding:0 20px\n}\n.tag-chips{line-height:43px\n}\n.tag-chips .v-input__control{margin-top:-9px\n}\n.tag-chips .v-chip{height:26px;padding:0 12px\n}\n.tag-chips .v-chip span{padding:0\n}", ""]);

// exports
